export const hideSvgModal = () => {
    const modal = document.querySelector(".contextmenu");
    if (modal) {
        modal.style.display = "none";
    }
};